























































































import Vue from "vue";

export default Vue.extend({
  name: "HealthOnboarding",
  props: {
    providerLabel: { type: String, required: true },
    canConnect: { type: Boolean, default: false },
    busy: { type: Boolean, default: false }
  }
});
